import React, { useEffect } from 'react'
import { rem } from 'polished'
import styled from 'styled-components'
import useOfferList from 'hooks/Offers/useOfferList'
import { useAppDispatch } from 'hooks/reduxHooks'
import { CRUISE_FLASH_OFFERS_FILTERS } from 'constants/cruise'
import { fetchToursPopularDestinations } from 'actions/GlobalSearch/GlobalSearchToursActions'
import Pane from 'components/Common/Pane'
import LayoutContainer from 'components/Common/LayoutContainer'
import Heading from 'LuxKit/Typography/Heading'
import Group from 'components/utils/Group'
import OfferListCarousel from 'components/OfferList/OfferListCarousel'
import { getThemeClassName } from 'lib/theme/themeUtils'

const PageContent = styled.div`
  padding: ${rem(60)} 0;
`

interface Props {
  cruiseLine: App.CruiseLine
}

const offerCampaignTags: Record<string, string> = {
  CEL: 'Celebrity Cruises',
  CUN: 'Cunard Cruises',
  HAL: 'HAL Cruises',
  POA: 'P&O Cruises',
  PCL: 'Princess Cruises',
  RCC: 'RCI Cruises',
  SRX: 'Silversea Cruises',
  MSC: 'MSC Cruises',
  NCL: 'Norwegian Cruise Line',
}

function CruiseFlashOffersCarousel({ cruiseLine }: Props) {
  const dispatch = useAppDispatch()
  const tag = offerCampaignTags[cruiseLine.code!]
  const offerList = useOfferList({
    ...CRUISE_FLASH_OFFERS_FILTERS,
    campaigns: [tag],
  })

  useEffect(() => {
    dispatch(fetchToursPopularDestinations())
  }, [dispatch])

  if (offerList.offerIds.length === 0 || !tag) {
    return null
  }

  return <Pane paletteType="inverse">
    <PageContent>
      <Group gap={24} direction="vertical">
        <LayoutContainer>
          <Heading variant="heading2">Our top <i>exclusive</i> {cruiseLine.name} offers</Heading>
        </LayoutContainer>

        <OfferListCarousel
          tileStyle="hero"
          overrideOfferList={offerList}
          className={getThemeClassName({ desktop: 'default' })}
        />
      </Group>
    </PageContent>
  </Pane>
}

export default CruiseFlashOffersCarousel
